import {Component, ViewChild, Inject, Input} from '@angular/core';
import {MatSnackBar, MatDialog} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';

import {forkJoin, Subscription} from 'rxjs';
import {tap} from 'rxjs/operators';

import { MapComponent, MapClickHandler, ClickDisplay} from '../../map.component'

import {MapService} from '../../../../commons/map.service';
import {BaseComponent} from '../../../../commons/BaseComponent';

@Component({
  selector: 'goej-comp',
  templateUrl: './geojson.component.html',
  styleUrls: ['../../map_commons.scss','./geojson.component.scss']
})
export class GeoJsonViewer extends BaseComponent implements MapClickHandler {


  icon:string
  meta:any
  cols:string[]
  aName:any

  constructor(route: ActivatedRoute, router: Router, snackBar: MatSnackBar, dialog: MatDialog, public mapComp: MapComponent, public mapService: MapService) {
    super(router, snackBar, dialog)


    this.addSubscription ( 'mapServiceReady',
      mapService.onReady().subscribe( _ =>
        route.params.subscribe(s => {
          var mapping = mapService.currentProject['meta_mapping']
  
          this.loading = true
          if (!this.mapComp.activeTab)
            this.mapComp.setTab('layers')
          this.mapService.scene.queryShapesAtPoint(parseFloat(s.lat), parseFloat(s.lng))
            .subscribe(s => {
                if (s.length) {
                  var v = s[0]
                  var attribs = Object.keys(v.attr).map(a => {
                    return {
                      key:a,
                      value:v.attr[a]
                    }
                  })
                  var hasName = Object.keys(v.attr).find(a => a == 'name')
                  
                  this.aName = hasName ? v.attr.name : null
  
                  if(mapping && mapping.title){
                    this.aName = attribs.find(a => a.key == mapping.title)
                    if(this.aName) this.aName = this.aName.value
                  }
                  this.meta = attribs.filter(a => {
                    if(mapping && mapping.excludes){
                      return mapping.excludes.indexOf(a.key) == -1
                    }
                    else if(mapping && mapping.includes){
                      return mapping.includes.indexOf(a.key) != -1
                    }
                    else
                      return a.key != 'name' && a.key != 'the_geom' && (!this.mapService.isAgronomeye || a.key != 'code')
                  }).sort((a, b) => {
                    if (a == b) return 0; else if (a > b) return 1; else return -1;
                  })
                  if(mapping && mapping.sort){
                    var oldA = this.meta
                    var newArray = []
                    mapping.sort.forEach(cur => {
                      var curA = oldA.find(a => a.key == cur)
                      if(curA){
                        newArray.push(curA)
                        oldA = oldA.filter(c => curA != c)
                      }
                    })
                    oldA.forEach(a => newArray.push(a))
                    this.meta = newArray
                  }
                  
  
                  this.meta = this.meta.map(k => {
                    return {key: mapping &&  mapping.fields && mapping.fields[k.key] ?  mapping.fields[k.key]:k.key, value: k.value}
                  })
                
                  if (!this.mapComp.detailsNav.opened)
                    this.mapComp.detailsNav.open();
  
                }
                else {
                  this.meta = null;
                  this.mapComp.detailsNav.close();
                }
  
                this.loading = false
              },
              e => {
                this.openSnackBarError(e.message)
                this.loading = false
              }
            )
        })
      )
    );
    
    // set the map views tabs to annotations
   // this.mapComp.setTab('layers')
    this.mapComp.activeDetails = this
    // open details draw
    this.mapComp.detailsNav.open()

  }

  clickedMap(movement: any, rightClick: boolean, checkedPosition):ClickDisplay{
    console.log ( 'geojson.comp :: clickedMap()');
    // pass actions to map
    return this.mapComp.activeTabObj.clickedMap(movement,rightClick, checkedPosition)
  }

}

